/*
    This function converts the prices of products that are fetched on the 
    client-side (Klevu products) as Shopify only converts prices that appear on 
    first page load (server-side).
*/
export const convertPrices = async (products = []) => {
    const { storefrontApi, currency } = shopifyData

    if (!storefrontApi || !storefrontApi.url || !storefrontApi.token) {
        console.error('No storefront API URL or token was provided.')
        return products
    }

    if (!products || !products.length || !currency) {
        console.error('No products or currency was provided.')
        return products
    } else if (currency.iso_code === currency.default) {
        return products
    }

    let convertedProducts = products

    const productQueries = products
        .map((product) => {
            return `p${product.id}: product(id: "gid://shopify/Product/${product.itemGroupId}") {
            priceRange {
                minVariantPrice {
                    amount
                }
                maxVariantPrice {
                    amount
                }
            }
            compareAtPriceRange {
                minVariantPrice {
                    amount
                }
            }
        }`})
        .join(',')

    const query = `query products @inContext(country: ${currency.country}) {
        ${productQueries}
    }`

    const graphqlBody = {
        async: true,
        crossDomain: true,
        method: 'POST',
        headers: {
            'X-Shopify-Storefront-Access-Token': storefrontApi.token,
            'Content-Type': 'application/graphql',
        },
        body: query,
    }

    const response = await fetch(storefrontApi.url, graphqlBody)
    const productData = await response.json()

    if (productData.errors) {
        console.error(productData.errors)
        return products
    }

    const singleDigitDecimalRegex = /^\d*\.\d{1}$/

    for (const [key, value] of Object.entries(productData.data)) {
        const id = key.replace('p', '')
        const product = convertedProducts.find((product) => product.id == id)

        if (product && value) {
            let minVariantPrice = value.priceRange.minVariantPrice.amount
            let maxVariantPrice = value.priceRange.maxVariantPrice.amount
            let compareAtPrice = value.compareAtPriceRange.minVariantPrice.amount

            // Shopify Storefront API returns a single digit decimal
            // for products that are a whole number e.g. 10.0
            if (singleDigitDecimalRegex.test(minVariantPrice))
                minVariantPrice = minVariantPrice + '0'

            if (singleDigitDecimalRegex.test(maxVariantPrice))
                maxVariantPrice = maxVariantPrice + '0'

            if (singleDigitDecimalRegex.test(compareAtPrice))
                compareAtPrice = compareAtPrice + '0'

            const formatNumber = (string) => {
                return Number(string.replaceAll('.', ''))
            }

            minVariantPrice = formatNumber(minVariantPrice)
            maxVariantPrice = formatNumber(maxVariantPrice)
            compareAtPrice = formatNumber(compareAtPrice)

            if (compareAtPrice > 0) {
                product.price = compareAtPrice
                product.startPrice = null
                product.salePrice = minVariantPrice
            } else {
                product.price = minVariantPrice
                product.startPrice = minVariantPrice !== maxVariantPrice ? minVariantPrice : null
                product.salePrice = compareAtPrice
            }
        }
    }

    return convertedProducts
}
